import useUserAPIStore from "apis/admin/user.api";
import { useAuth } from "hooks/Auth/useAuth";
import { useEffect } from "react";

export const useBootstrapAuth = () => {
  const { isLoggedIn, token, setUser } = useAuth();
  const { getUser } = useUserAPIStore();

  const getUserInfo = async (userId: string) => {
    const userInfo = await getUser(userId);
    if (userInfo) setUser(userInfo);
  };

  useEffect(() => {
    if (isLoggedIn && token) getUserInfo(token.userId);
  }, [isLoggedIn]);

  return null;
};
